import { languageMap } from ".."

languageMap["arm-asm"] =
	languageMap.armasm =
	languageMap.asm6502 =
	languageMap.asmatmel =
	languageMap.nasm =
		{ comments: { line: ";" } }
